import React, { useRef, useEffect } from "react";
import _ from "lodash";
import TYPE from "../../../../constant/TYPE";
import Result from "./Result";

const DistributiveLaw = ( props ) => {

  const prevData = useRef( [] );
  const mathjaxRenderCount = useRef( 0 );

  useEffect( () => {
    ! _.isEqual( prevData.current[ 0 ], data[ 0 ] ) && renderMathJax();
  }, [ props.children ] );

  const startKeyword = `\\begin{${ TYPE.LATEX_CODE.DISTRIBUTIVE_LAW }}`;
  const endKeyword = `\\end{${ TYPE.LATEX_CODE.DISTRIBUTIVE_LAW }}`;

  const mapData = ( value, index ) => {
    if ( index ) {
      return value.slice( 0, value.indexOf( '\\end{array}' ) ).split( '\\\\' ).map( v => v.split( '&' ).map( v => v.trim() ) );
    } else {
      const data = value.split( '[' ).join( '' ).split( ']' ).map( v => v.trim() );
      return {
        style : { width : data[ 1 ], height : data[ 2 ] },
        src : data[ 3 ].slice( data[ 3 ].indexOf( '{' ) + 1, data[ 3 ].indexOf( '}' ) ).trim()
      };
    }
  };

  const data = props.children.slice( props.children.indexOf( startKeyword ) + startKeyword.length, props.children.indexOf( endKeyword ) ).split( '\\begin{array}' ).map( mapData );
  const changedDataCount = data.reduce( ( r, v, i ) => r + ( _.isEqual( prevData.current[ i ], v ) ? 0 : 1 ), 0 );

  const renderMathJax = () => {
    mathjaxRenderCount.current++;
    if ( changedDataCount === mathjaxRenderCount.current ) {
      prevData.current = data;
      mathjaxRenderCount.current = 0;
      props.onRender();
    }
  };

  return (
    <div className="calcEdit-popInputBox">
      <div className="img_cont">
        <img { ...data[ 0 ] } alt="" />
      </div>
      <div className="r_cont">
        <Result type={ props.type } data={ data[ 1 ] } onRender={ renderMathJax } />
      </div>
    </div>
  );

};

export default DistributiveLaw;
